import { Box, Modal } from "@mui/material";
import { SystemStyleObject, Theme } from "@mui/system";

type Props = {
  sx: SystemStyleObject<Theme>;
  children: React.ReactNode;
};

export default function FullscreenBox({ children, sx }: Props) {
  return (
    <Modal
      open
      hideBackdrop
      disableAutoFocus
      role="dialog"
      sx={{
        overflowY: "auto",
        ...sx,
      }}
    >
      <Box sx={{ outline: "none" }}>{children}</Box>
    </Modal>
  );
}
